import './ThemedButton.css';
import React from 'react';

interface ThemedButtonProps {
  text: string;
  onClick: () => void;
  color?: 'primary' | 'white';
}

function ThemedButton({ text, onClick, color }: ThemedButtonProps) {
  return (
    <button className={`themed-button ${color ?? 'primary'}`} onClick={onClick}>
      {text}
    </button>
  );
}

export default ThemedButton;
